module.exports = __webpack_public_path__ + "img/DSC_2737.ca31da80.png";